import React from 'react';




// --------------- Dashboard Section Pages -----------------------
const DashboardLazy = React.lazy(() => import('../Pages/HomePage'));
const AppBannerLazy = React.lazy(() => import('../Pages/AppBanners'));
const AreasLazy = React.lazy(() => import('../Pages/Areas'));
const CategoriesLazy = React.lazy(() => import('../Pages/Categories'));
const ServicesLazy = React.lazy(() => import('../Pages/Services'));
const ServiceMenLazy = React.lazy(() => import('../Pages/ServiceMen'));
const AddServiceMenLazy = React.lazy(() => import('../Pages/ServiceMen/AddServiceMenPage'))
const UsersLazy = React.lazy(() => import('../Pages/Users'));
const BookingsLazy = React.lazy(() => import('../Pages/Bookings'))
const SettingsLazy = React.lazy(() => import('../Pages/Settings'));
const AppMetaLazy = React.lazy(() => import('../Pages/InfoPages/AppMetaPage'));






// Catch-all route for 404
const Error404PageLazy = React.lazy(() => import('../Pages/Error404Page'));





const routes = [

    // --------------- Default Section Pages -----------------------
    { path: '/dashboard', exact: true, name: 'Default', element: <DashboardLazy /> },
    { path: '/app-banners', exact: true, name: 'AppBanner', element: <AppBannerLazy /> },
    { path: '/areas-master', exact: true, name: 'AppBanner', element: <AreasLazy /> },
    { path: '/categories-master', exact: true, name: 'AppBanner', element: <CategoriesLazy /> },
    { path: '/services-master', exact: true, name: 'AppBanner', element: <ServicesLazy /> },
    { path: '/service-mens', exact: true, name: 'AppBanner', element: <ServiceMenLazy /> },
    { path: '/add-service-mens', exact: true, name: 'AppBanner', element: <AddServiceMenLazy /> },
    { path: '/users', exact: true, name: 'AppBanner', element: <UsersLazy /> },
    { path: '/bookings', exact: true, name: 'AppBanner', element: <BookingsLazy /> },
    { path: '/settings', exact: true, name: 'AppBanner', element: <SettingsLazy /> },
    { path: '/app-meta', exact: true, name: 'AppBanner', element: <AppMetaLazy /> },



    // Catch-all route for 404
    { path: '*', exact: true, name: 'Default', element: <Error404PageLazy /> },
];



// Function to get routerKey by path
export const getRouterKeyByPath = (path) => {
    const route = routes.find(route => route.path === path);
    return route ? route.routerKey : 'UNKNOWN';
};

export default routes;